import PropTypes from "prop-types";
import { Grid, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { Doughnut } from "react-chartjs-2";
import { CARRIER_COLORS, GraphicNoDataImg } from "../constants/graphics";
import ChartPlaceholder from "./chartPlaceholder";
import { formatNumberShort } from "../../../helpers/functions/functions";

// Envío por operadora del mes actual: dona con el reparto entre Movistar, Digitel y Movilnet
const CarrierDonutChart = ({
  classes,
  darkMode,
  loading,
  noData,
  movistarAmount,
  digitelAmount,
  movilnetAmount,
}) => {
  const totalOperatorMessages = movistarAmount + digitelAmount + movilnetAmount;

  const getPercent = (amount) =>
    totalOperatorMessages
      ? Math.round((amount * 100) / totalOperatorMessages)
      : 0;

  const secondaryCarriers = [
    { label: "Digitel", amount: digitelAmount },
    { label: "Movilnet", amount: movilnetAmount },
  ];

  return (
    <Grid
      item
      container
      direction={"column"}
      className={classes.carrierGraphicContainer}
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        backgroundColor: darkMode ? "#000000DE" : "#FFFFFF",
        border:
          "1px solid " + (darkMode ? "rgba(224, 224, 224, 0.50)" : "#E0E0E0"),
        boxShadow: "0 2px 8px 0 rgba(0, 0, 0, 0.10)",
      }}
    >
      <Grid
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "92%",
          alignItems: "start",
        }}
      >
        <Typography
          variant="p"
          className={classes.dashboardHeaderSubTitle}
          sx={{
            fontWeight: "500 !important",
            marginLeft: "5px",
            color: "black",
            fontSize: "18px !important",
          }}
        >
          {" "}
          Envío por operadora{" "}
        </Typography>
        <Typography
          sx={{
            fontWeight: 300,
            fontSize: "13px",
            marginLeft: "5px",
            color: darkMode ? "white" : "black",
            fontFamily: "Ubuntu !important",
          }}
          variant="spam"
        >
          Mes actual
        </Typography>
      </Grid>

      <Grid
        item
        container
        direction={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        sx={{
          width: "100%",
          flex: 1,
          minHeight: 0,
          marginTop: "10px",
        }}
      >
        {loading === false && !noData ? (
          <Grid
            sx={{
              width: "100%",
              marginLeft: window.innerWidth > 1500 ? "8%" : "0",
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
              justifyContent: "space-between",
              gap: { xs: 2, md: 3 },
              px: { xs: 0, md: 1 },
            }}
          >
            <Box
              sx={{
                width: "230px",
                aspectRatio: "1 / 1",
                position: "relative",
              }}
            >
              <Doughnut
              style={{position: "relative", zIndex: "10"}}
                data={{
                  labels: ["Movistar", "Digitel", "Movilnet"],
                  datasets: [
                    {
                      data: [movistarAmount, digitelAmount, movilnetAmount],
                      backgroundColor: [
                        CARRIER_COLORS.MOVISTAR,
                        CARRIER_COLORS.DIGITEL,
                        CARRIER_COLORS.MOVILNET,
                      ],
                      borderWidth: 0,
                      hoverBorderWidth: 0,
                    },
                  ],
                }}
                options={{
                  responsive: true,
                  maintainAspectRatio: false,
                  rotation: 90,
                  cutout: "74%",
                  plugins: {
                    legend: { display: false },
                    tooltip: {
                      enabled: true,
                      backgroundColor: !darkMode ? "white" : "#4E4E4E",
                      bodyColor: !darkMode ? "#000" : "white",
                      borderColor: !darkMode ? "#1BC3DD" : "#1BC3DD",
                      borderWidth: 1,
                      titleColor: !darkMode ? "#000" : "white",
                      displayColors: false,
                    },
                    datalabels: { display: false },
                  },
                }}
              />

              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  pointerEvents: "none",
                }}
              >
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    sx={{
                      fontFamily: "Ubuntu !important",
                      fontWeight: "700 !important",
                      fontSize: "38.29px",
                      color: darkMode
                        ? "rgba(255, 255, 255, 0.70)"
                        : "rgba(0, 0, 0, 0.70)",
                      lineHeight: 1,
                    }}
                  >
                    {getPercent(movistarAmount)}%
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Ubuntu !important",
                      fontWeight: 300,
                      fontSize: "18px",
                      color: darkMode ? "#fff" : "#000",
                      lineHeight: 1.2,
                    }}
                  >
                    {formatNumberShort(movistarAmount)}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Ubuntu !important",
                      fontWeight: 400,
                      fontSize: "18px",
                      color: darkMode ? "white" : "#000",
                      lineHeight: 1.2,
                    }}
                  >
                    Movistar
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                width: { xs: "100%", md: "100%" },
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-evenly",
                marginRight: "5%",
                gap: "6vw",
                alignItems: "center",
                textAlign: { xs: "center", md: "left" },
              }}
            >
              {secondaryCarriers.map(({ label, amount }) => (
                <Box key={label}>
                  <Typography
                    sx={{
                      fontFamily: "Ubuntu !important",
                      fontWeight: "500 !important",
                      fontSize: "30px",
                      color: darkMode
                        ? "rgba(255, 255, 255, 0.70)"
                        : "rgba(0, 0, 0, 0.70)",
                      lineHeight: 1,
                    }}
                  >
                    {getPercent(amount)}%
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Ubuntu !important",
                      fontWeight: 400,
                      fontSize: "18px",
                      color: darkMode ? "white" : "#111111",
                      lineHeight: 1.2,
                    }}
                  >
                    {label}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Ubuntu !important",
                      fontWeight: 300,
                      fontSize: "16px",
                      color: darkMode ? "white" : "#111111",
                      lineHeight: 1.2,
                    }}
                  >
                    {formatNumberShort(amount)}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Grid>
        ) : (
          <ChartPlaceholder
            darkMode={darkMode}
            loading={loading}
            image={
              darkMode
                ? GraphicNoDataImg.NoDataPieDark
                : GraphicNoDataImg.NoDataPieWhite
            }
          />
        )}
      </Grid>
    </Grid>
  );
};

CarrierDonutChart.propTypes = {
  classes: PropTypes.object.isRequired,
  darkMode: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  noData: PropTypes.bool.isRequired,
  movistarAmount: PropTypes.number.isRequired,
  digitelAmount: PropTypes.number.isRequired,
  movilnetAmount: PropTypes.number.isRequired,
};

export default CarrierDonutChart;
